var quickAdd = document.querySelectorAll('.product-card__quick-add');

if(quickAdd) {
    quickAdd.forEach(function (productQuickAdd) {
        updateVarianteSelected(productQuickAdd);
        variantAvailability(productQuickAdd);
        closeVariantSelectors(productQuickAdd);
        openSizeChartModal(productQuickAdd);
        addToCart(productQuickAdd);

        if(productQuickAdd.querySelector('.color__fieldset')) {
            var colorSwatch = productQuickAdd.querySelectorAll('.color__label');
            colorSwatch.forEach(function (element) {
                element?.addEventListener("click", function (e) {
                    productQuickAdd.querySelectorAll('.color__label').forEach(function (element) {
                        element.classList.remove('color__label--active');
                    });
                    element.classList.add('color__label--active');
                    productQuickAdd.querySelector('.product-card__label span').innerHTML = e.target.dataset.value;
                    updateVarianteSelected(productQuickAdd);
                    variantAvailability(productQuickAdd);
                    closeVariantSelectors(productQuickAdd);
                    openSizeChartModal(productQuickAdd);
                    addToCart(productQuickAdd);
                });
            });
            if(!productQuickAdd.querySelector('.size__fieldset')) {
                if (productQuickAdd.querySelector('.product-card__actions--atc').classList.contains('hide')) {
                    productQuickAdd.querySelector('.product-card__actions--atc').classList.remove('hide');
                    productQuickAdd.querySelector('.product-card__actions--size').classList.add('hide');
                }
            }
        }

        if(productQuickAdd.querySelector('.size__fieldset')) {
            var sizeSwatch = productQuickAdd.querySelectorAll('.size__label');
            sizeSwatch.forEach(function (element) {
                element?.addEventListener("click", function (e) {
                    productQuickAdd.querySelectorAll('.size__label').forEach(function (element) {
                        element.classList.remove('size__label--active');
                    });
                    element.classList.add('size__label--active');
                    if (productQuickAdd.querySelector('.product-card__actions--atc').classList.contains('hide')) {
                        productQuickAdd.querySelector('.product-card__actions--atc').classList.remove('hide');
                        productQuickAdd.querySelector('.product-card__actions--size').classList.add('hide');
                    }
                    if (productQuickAdd.querySelector('.product-card__close').classList.contains('hide')) {
                        productQuickAdd.querySelector('.product-card__close').classList.remove('hide');
                    }
                    updateVarianteSelected(productQuickAdd);
                    variantAvailability(productQuickAdd);
                    closeVariantSelectors(productQuickAdd);
                    openSizeChartModal(productQuickAdd);
                    addToCart(productQuickAdd);
                });
            });
        }
    });
}

function updateVarianteSelected(quickAddComponent) {
    var quickAdd = quickAddComponent;
    var option1 = "";
    var option2 = "";
    let isColorFirstOption = true;
    var variantSelected = "";
    quickAdd.querySelectorAll('.color__label').forEach(function (element) {
        if(element.classList.contains('color__label--active')) {
            option1 = element.dataset.value;
            isColorFirstOption = element.dataset.isColorFirstOption;
        }
    });
    quickAdd.querySelectorAll('.size__label').forEach(function (element) {
        if(element.classList.contains('size__label--active')) {
            option2 = element.dataset.value;
        }
    });
    if(option2 != null && option2 != undefined && option2 != "") {
        if(isColorFirstOption) variantSelected = option2 + " / " + option1;
        else variantSelected = option1 + " / " + option2;
    } else {
        variantSelected = option1;
    }
    if(quickAdd.querySelector('.product-card__variants')) {
        var options = quickAdd.querySelectorAll('.product-card__variants--select option');
        options.forEach(function (option) {
            if(option.dataset.variantTitle == variantSelected) {
                option.selected = true;
                quickAdd.querySelector('.product-card__meta--media img').src = option.dataset.media;
                quickAdd.querySelector('.product-card__meta--media img').srcset = option.dataset.media;

                quickAdd.parentNode.querySelector('img.grid__image-contain').src = option.dataset.media;
                quickAdd.parentNode.querySelector('img.grid__image-contain').srcset = option.dataset.media;

                quickAdd.querySelector('.product-card__product-form--input').value = option.dataset.variantId;
                quickAdd.querySelector('.product-card__product-form--input').dataset.variantAvailable = option.dataset.variantAvailable;   
            }
        });
    }
}

function variantAvailability(quickAddComponent) {
    var quickAdd = quickAddComponent;
    var input = quickAdd.querySelector('.product-card__product-form--input');
    if (JSON.parse(input.dataset.variantAvailable) === true) {
        quickAdd.querySelector('.product-card__actions--atc span').innerText = "Add To Cart";
        quickAdd.querySelector('.product-card__actions--atc').disabled = false;
    } else {
        quickAdd.querySelector('.product-card__actions--atc span').innerText = "Sold Out";
        quickAdd.querySelector('.product-card__actions--atc').disabled = true;
    }
}

function closeVariantSelectors(quickAddComponent) {
    var quickAdd = quickAddComponent;
    var closeButton = quickAdd.querySelector('.product-card__close');
    if (closeButton) {
        closeButton?.addEventListener("click", function (e) {
            if(window.screen.width > 769) {
                quickAdd.classList.add('product-card__quick-add--compressed');
                setTimeout(function () {
                    quickAdd.classList.remove('product-card__quick-add--compressed');
                }, 2000);
            }
            if(window.screen.width < 769) {
                if (quickAdd.classList.contains('product-card__quick-add--displayed')) {
                    quickAdd.classList.remove('product-card__quick-add--displayed');   
                }
                if(document.querySelector('.modal-overlay')) {
                    if(!document.querySelector('.modal-overlay').classList.contains('hide')) {
                        document.querySelector('.modal-overlay').classList.add('hide');
                    }
                }
            }
        });
    }
}

function addToCart(quickAddComponent) {
    var quickAdd = quickAddComponent;
    var addToCartButton = quickAdd.querySelector('.product-card__actions--atc');
    if (addToCartButton) {
        addToCartButton?.addEventListener("click", function (e) {
            e.preventDefault();
            var inputId = quickAdd.querySelector('.product-card__product-form--input').value;
            let formData = {
                'items': [
                    {
                        'id': inputId,
                        'quantity': 1
                    }
                ]
            };
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            }).then(response => {
                var cart = new theme.CartDrawer
                cart.init()
                cart.open();
                return response.json();
            }).catch((error) => {
                console.error('Error:', error);
            });
        });
    }
}

function openSizeChartModal(quickAddComponent) {
    var quickAdd = quickAddComponent;
    var sizeChartTrigger = quickAdd.querySelector('.product-card__label--size-chart[data-size-chart-trigger]');
    var sizeChartContent = quickAdd.querySelector('.size-chart-content');
    sizeChartTrigger?.addEventListener("click", function (e) {
        console.log(e);
        if(document.querySelector('.size-chart-pop-up')) {
            if(document.querySelector('.size-chart-pop-up').classList.contains('hide')) {
                document.querySelector('.size-chart-pop-up').classList.remove('hide');
            }
            document.querySelector('.size-chart-pop-up__body--content').innerHTML = sizeChartContent.innerHTML;
        }
    });
}

var productItem = document.querySelectorAll('.grid-product__content');

if (productItem) {
    productItem.forEach(function (item) {
        openVariantSelectorsOnMobile(item);
    });
}

function openVariantSelectorsOnMobile(element) {
    var productContent = element;
    productContent.querySelector('.product-card__trigger--shop')?.addEventListener("click", function (e) {
        if (!productContent.querySelector('.product-card__quick-add').classList.contains('product-card__quick-add--displayed')) {
            productContent.querySelector('.product-card__quick-add').classList.add('product-card__quick-add--displayed');
        }
        if(document.querySelector('.modal-overlay')) {
            if(document.querySelector('.modal-overlay').classList.contains('hide')) {
                document.querySelector('.modal-overlay').classList.remove('hide');
            }
        }
    });
}